/* @flow */

import React, { Component } from 'react';
import { Grid, Header, Form, Divider, Button, Icon } from 'semantic-ui-react';
import ResourceCard from './ResourceCard';
import ResourceDimmer from './ResourceDimmer';
import ImageCrop from './ImageCrop';
import { ChromePicker } from 'react-color';
import { VERTICAL_ALIGNS, HORIZONTAL_ALIGNS } from 'shared/constants/resources';
import { getImage } from 'utils/resources';

export type FixedDimensionConfig = {
  fullWidth?: boolean,
  fullHeight?: boolean,
  align: string,
  color: string,
  x?: number,
  y?: number,
  width?: number,
  height?: number,
};

type Props = {
  resource?: BucketResource,
  config?: FixedDimensionConfig,
  onSelected: (resource: BucketResource) => void,
  onConfigChanged: (config: FixedDimensionConfig) => void,
  onDeleted: () => void,
};

type State = {
  cropOpen: boolean,
};

class FixedDimensionResourceCard extends Component {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      cropOpen: false,
    };
  }

  onShowCrop = () => this.setState({ cropOpen: true });
  onHideCrop = () => this.setState({ cropOpen: false });

  onResourceCrop = (crop: CropConfig) => {
    const { resource, config } = this.props;
    if (!resource) {
      console.warn('Trying to crop image without source');
      return;
    }

    this.setState(
      {
        cropOpen: false,
      },
      () =>
        this.props.onConfigChanged({
          ...config,
          ...crop,
        })
    );
  };

  onAlignChanged = (_, { value: align }) =>
    this.props.onConfigChanged({
      ...this.props.config,
      align,
    });

  onColorChanged = value =>
    this.props.onConfigChanged({
      ...this.props.config,
      color: value.hex,
    });

  renderDimmer() {
    const { resource } = this.props;

    return (
      <ResourceDimmer resource={resource}>
        <Button
          type="button"
          primary
          icon
          labelPosition="right"
          onClick={this.onShowCrop}
        >
          <Icon name="crop" />
          Redimensionner
        </Button>
      </ResourceDimmer>
    );
  }

  render() {
    const { resource, config, onSelected, onDeleted } = this.props;
    const { cropOpen } = this.state;

    const fieldDisabled = !resource;

    return (
      <Grid>
        <Grid.Row columns={2} divided>
          <Grid.Column>
            <Header as="h3" textAlign="center">Image Cible</Header>
            <ResourceCard
              resourceType="image"
              resource={resource}
              onSelected={onSelected}
              onDeleted={onDeleted}
            >
              {this.renderDimmer()}
            </ResourceCard>
            {resource &&
              <ImageCrop
                open={cropOpen}
                fullWidth={config.fullWidth}
                fullHeight={config.fullHeight}
                onClose={this.onHideCrop}
                config={config}
                image={getImage(resource, 'xhdpi_2x')}
                onComplete={this.onResourceCrop}
              />}
          </Grid.Column>
          <Grid.Column>
            <Header as="h3" textAlign="center">Configuration</Header>
            <Divider hidden />
            <Form>
              {config.fullWidth &&
                <Form.Select
                  value={config.align}
                  onChange={this.onAlignChanged}
                  disabled={fieldDisabled}
                  label="Alignement horizontal"
                  name="horizontalAlign"
                  options={HORIZONTAL_ALIGNS}
                />}
              {config.fullHeight &&
                <Form.Select
                  value={config.align}
                  onChange={this.onAlignChanged}
                  disabled={fieldDisabled}
                  label="Alignement vertical"
                  name="verticalAlign"
                  options={VERTICAL_ALIGNS}
                />}
              <Form.Field disabled={fieldDisabled}>
                <label>Couleur de remplissage</label>
                <ChromePicker
                  color={config.color}
                  onChangeComplete={this.onColorChanged}
                  disableAlpha
                />
              </Form.Field>
            </Form>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default FixedDimensionResourceCard;



// WEBPACK FOOTER //
// ./src/shared/components/FixedDimensionResourceCard.js